import React from 'react'
import { cn } from '../../utils/cn'
import Delta from './Delta'

/**
 * Stat — a single metric: kicker label, large tabular value, optional delta + footnote.
 * The workhorse of the dashboard. Value is pre-formatted by the caller (string or node).
 *
 *   <Stat kicker="Portfolio value" value="₹1.24Cr" delta={{ value: 18400, pct: 1.5 }} foot="all accounts" />
 */
export default function Stat({
  kicker, value, delta, foot, icon: Icon, size = 'md', align = 'left', className,
}) {
  const sizes = {
    sm: 'text-xl',
    md: 'text-[28px] leading-none',
    lg: 'text-[40px] leading-[1.05]',
    xl: 'text-[56px] leading-[1.02]',
  }
  return (
    <div className={cn(align === 'right' && 'text-right', className)}>
      <div className={cn('flex items-center gap-1.5', align === 'right' && 'justify-end')}>
        {Icon && <Icon className="w-3.5 h-3.5 text-ink-400" />}
        <span className="kicker">{kicker}</span>
      </div>
      <div className={cn('stat-value mt-1.5', sizes[size] || sizes.md)}>{value}</div>
      {(delta || foot) && (
        <div className={cn('mt-2 flex items-center gap-2 flex-wrap', align === 'right' && 'justify-end')}>
          {delta && <Delta value={delta.value} pct={delta.pct} compact={delta.compact} size="sm" />}
          {foot && <span className="text-xs text-ink-400">{foot}</span>}
        </div>
      )}
    </div>
  )
}
